@if (historyItems.length) {
  <div class="d-flex flex-column gap-3">
    @for (item of historyItems; track item.createdAt) {
      <div class="border rounded p-3">
        <div class="fw-semibold mb-2">{{ item.createdAt | dateTime }}</div>

        <div class="d-flex flex-column gap-2">
          @if (hasStatusChange(item)) {
            <div class="row g-2">
              <div class="col-12 col-md-4 text-muted">{{ 'deviceHistory.fields.status' | translate }}</div>
              <div class="col-12 col-md-8">{{ statusTransitionLabel(item) }}</div>
            </div>
          }

          @if (hasAssignedOrganizationChange(item)) {
            <div class="row g-2">
              <div class="col-12 col-md-4 text-muted">{{ 'deviceHistory.fields.assignedOrganization' | translate }}</div>
              <div class="col-6 col-md-4">{{ organizationLabel(item.oldAssignedOrganization) }}</div>
              <div class="col-6 col-md-4">{{ organizationLabel(item.newAssignedOrganization) }}</div>
            </div>
          }

          @if (hasUsingOrganizationChange(item)) {
            <div class="row g-2">
              <div class="col-12 col-md-4 text-muted">{{ 'deviceHistory.fields.usingOrganization' | translate }}</div>
              <div class="col-6 col-md-4">{{ organizationLabel(item.oldUsingOrganization) }}</div>
              <div class="col-6 col-md-4">{{ organizationLabel(item.newUsingOrganization) }}</div>
            </div>
          }

          @if (hasSeenOrganizationChange(item)) {
            <div class="row g-2">
              <div class="col-12 col-md-4 text-muted">{{ 'deviceHistory.fields.seenOrganization' | translate }}</div>
              <div class="col-6 col-md-4">{{ organizationLabel(item.oldSeenOrganization) }}</div>
              <div class="col-6 col-md-4">{{ organizationLabel(item.newSeenOrganization) }}</div>
            </div>
          }
        </div>
      </div>
    }
  </div>
} @else {
  <p class="mb-0 text-muted fst-italic">{{ 'deviceHistory.empty' | translate }}</p>
}
